import { lazy } from "react";

export const LazyRetrievalQueriesDownloadModal = lazy(() =>
  import(
    /* webpackChunkName: "retailer-retrieval-queries-download-modal" */ "./RetrievalQueriesDownloadModal"
  ).then((m) => ({ default: m.RetrievalQueriesDownloadModal }))
);
